import TemplateView from '../TemplateView'
import linkifyString from 'linkifyjs/string'

export class LinkifiedText extends TemplateView {
    constructor() {
        super()

        this.state = {
            text: '',
        }

        this.onStatePropertyChanged('text', text => {
            if (!!text) this.$el.html(linkifyString(text)).find('a').click(e => e.stopPropagation())
        })
    }

    templateHtml() {
        return '<div class="components_linkifiedText"/>'
    }
}


// WEBPACK FOOTER //
// ./web/js/components/LinkifiedText.js